<template>
  <div>
    <v-layout
      wrap
      justify-center
      :style="{
        'padding-top':
          $vuetify.breakpoint.name == 'xs'
            ? '10px'
            : $vuetify.breakpoint.name == 'sm'
            ? '30px'
            : $vuetify.breakpoint.name == 'md'
            ? '150px'
            : $vuetify.breakpoint.name == 'lg'
            ? '150px'
            : '150px',
      }"
    >
      <v-flex xs12 sm6 md6 text-center>
        <v-img
          height="140px"
          alt="./../../assets/brushcopy1.png"
          lazy-src="./../../assets/brushcopy1.png"
          src="./../../assets/brushcopy1.png"
        >
          <span class="history"> Media</span>
        </v-img>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs11 sm10 md8 text-left pb-10>
        <span style="font-family: brandonBold; font-size: 30px; color: black"
          >News</span
        >
        <v-layout wrap justify-center v-for="(item, i) in itemArray" :key="i">
          <v-flex pt-5>
            <v-card height="120px">
              <v-layout wrap justify-start>
                <v-flex xs2 sm2 md2 align-self-start pt-2>
                  <v-img contain height="100px" :src="item.img"></v-img>
                </v-flex>
                <v-flex xs10 sm10 pa-4>
                  <span class="itemTest">{{ item.name }}</span> <br />
                  <br />
                  <v-layout wrap justify-center>
                    <v-flex xs6 sm3>
                      <span class="itemDate">{{ item.date }}</span>
                    </v-flex>
                    <v-flex xs6 sm9>
                      <router-link
                        to="/mediaDetails"
                        style="text-decoration: none"
                      >
                        <span style="font-family: sofiaProMedium; color: black"
                          >Read More</span
                        >
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs11 sm10 md8 text-left pb-10>
        <span style="font-family: brandonBold; font-size: 30px; color: black"
          >Events</span
        >
        <v-layout wrap justify-center v-for="(list, i) in eventArray" :key="i">
          <v-flex pt-5>
            <v-card height="120px">
              <v-layout wrap justify-start>
                <v-flex xs2 sm2 md2 align-self-start pt-2>
                  <v-img contain height="100px" :src="list.img"></v-img>
                </v-flex>
                <v-flex xs10 sm10 pa-4>
                  <span class="itemTest">{{ list.name }}</span> <br />
                  <br />
                  <v-layout wrap justify-center>
                    <v-flex xs6 sm3>
                      <span class="itemDate">{{ list.date }}</span>
                    </v-flex>
                    <v-flex xs6 sm9>
                      <router-link
                        to="/mediaDetails"
                        style="text-decoration: none"
                      >
                        <span style="font-family: sofiaProMedium; color: black"
                          >Read More</span
                        >
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      itemArray: [
        {
          name: "Demo Test News",
          img: "https://www.experiencetravelgroup.com/reposit/390_20180508182436.jpg",
          date: "10 Sep 2022",
        },
        {
          name: "Demo Test",
          img: "https://www.keralatourism.org/images/malabar/static-banner/large/Nelliyampathy-25102019111300.JPG",
          date: "10 Sep 2022",
        },
        {
          name: "Demo Test News",
          img: "https://www.experiencetravelgroup.com/reposit/390_20180508182436.jpg",
          date: "10 Sep 2022",
        },
      ],
      eventArray: [
        {
          name: "Demo Test Event",
          img: "https://thumbs.dreamstime.com/b/nelliyampathy-tea-estate-hill-view-211659812.jpg",
          date: "10 Sep 2022",
        },
        {
          name: "Event New",
          img: "https://www.keralatourism.org/images/malabar/static-banner/large/Nelliyampathy-25102019111300.JPG",
          date: "10 Sep 2022",
        },
        {
          name: "Demo Test",
          img: "https://thumbs.dreamstime.com/b/nelliyampathy-tea-estate-hill-view-211659812.jpg",
          date: "10 Sep 2022",
        },
      ],
    };
  },
};
</script>
<style>
.itemTest {
  font-family: sofiaProSemiBold;
  font-size: 25px;
  color: black;
}
.itemDate {
  font-family: sofiaProSemiBold;
  font-size: 20px;
  color: grey;
}
</style>
